import { FusePageSimple } from '@fuse';
import _ from '@lodash';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import AnotacaoList from './AnotacaoList';
import AnotacaoDialog from './Dialogs/AnotacaoDialog';
import NewAnotacao from './NewAnotacao';

class AnotacaoApp extends XAPPComponent {

    state = {
        open: null
    }

    openDialog = (_AValue) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    }

    render() {
        let pageLayout = null;
        const { handleChangeAnotacoes, anotacoes = [] } = this.props;
        return (
            <React.Fragment>
                <FusePageSimple
                    classes={{
                        //contentWrapper: "p-16 sm:p-24 pb-80",
                        content: "flex min-h-full",
                        leftSidebar: "w-256 border-0",
                        header: "min-h-72 h-72"
                    }}
                    content={
                        <div className="flex flex-col w-full items-center">
                            <NewAnotacao
                                handleChangeAnotacoes={handleChangeAnotacoes}
                            />
                            <AnotacaoList
                                anotacoes={anotacoes}
                                openDialog={this.openDialog}
                            />
                            <AnotacaoDialog
                                handleChangeAnotacoes={handleChangeAnotacoes}
                                openDialog={this.openDialog}
                                open={this.state.open}
                            />
                        </div>
                    }
                    sidebarInner
                    onRef={instance => {
                        pageLayout = instance;
                    }}
                    innerScroll
                />
            </React.Fragment>
        )
    }
}

export default AnotacaoApp;
